import React, { Fragment, PureComponent } from 'react'
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import {
  Done,
  MoreVert,
  Print,
  Delete,
  Edit,
  Check,
  RemoveCircleOutline,
  CallMissedOutgoing,
  CallReceived,
  BlockRounded
} from '@material-ui/icons'

export class BookingOptionsBase extends PureComponent {
  state = {
    anchorEl: null
  }

  onOptionClick = type => () => {
    const {
      editBooking,
      deleteBooking,
      booking,
      setBookingStatus,
      showModal,
      addBlacklistBooking
    } = this.props

    const { id, status } = booking

    /* eslint-disable */
    switch (type) {
      case 'print':
        showModal({ type: 'printTickets', data: { bookings: [booking] } })
        break
      case 'delete':
        deleteBooking(booking)
        break
      case 'edit':
        editBooking()
        break
      case 'blacklist':
        addBlacklistBooking(booking)
        break
      default:
        setBookingStatus({ id, status, type })
    }
    /* eslint-enable */

    this.handleClose()
  }

  submitEditing = () => {
    const { submitEditing } = this.props

    submitEditing()

    this.handleClose()
  }

  menuItems = () => {
    const { booking: { status } } = this.props

    const confirmLabel = status === 'confirmed' ? 'Скасувати' : 'Підтвердити'
    const confirmIcon = status === 'confirmed' ? RemoveCircleOutline : Check

    const responseLabel = status === 'noResponse' ? 'Відповів' : 'Не відповідає'
    const responseIcon = status === 'noResponse' ? CallReceived : CallMissedOutgoing

    return [
      { id: 'print', label: 'Квитки', icon: Print },
      { id: 'delete', label: 'Видалити', icon: Delete },
      { id: 'edit', label: 'Редагувати', icon: Edit },
      { id: 'confirm', label: confirmLabel, icon: confirmIcon },
      { id: 'response', label: responseLabel, icon: responseIcon },
      { id: 'blacklist', label: 'В чорний список', icon: BlockRounded },
    ]
  }

  handleOpen = e => this.setState({ anchorEl: e.currentTarget })

  handleClose = () => this.setState({ anchorEl: null })

  renderMenuItem = ({ id, label, icon: Icon }) => (
    <MenuItem key={id} onClick={this.onOptionClick(id)}>

      <ListItemIcon>
        <Icon />
      </ListItemIcon>

      <ListItemText inset primary={label} />

    </MenuItem>
  )

  render() {
    const { anchorEl } = this.state
    const { isEditing } = this.props

    return (
      <Fragment>
        {isEditing
          ? (
            <IconButton onClick={this.submitEditing}>
              <Done />
            </IconButton>
          )
          : (
            <IconButton onClick={this.handleOpen}>
              <MoreVert />
            </IconButton>
          )}
        <Menu
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          anchorEl={anchorEl}
        >
          {this.menuItems().map(this.renderMenuItem)}
        </Menu>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingOptions/BookingOptions.js